// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormHelperText,
    Typography,
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Autocomplete
} from '@mui/material'

import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../icon';
import apiUrl from '../../configs/constant';
import MsiDatagrid from '../custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { Controller, useForm } from 'react-hook-form'
import { useToast } from '../ToastProvider'
import { getDoctag, getGudang } from '../../api/helper'
import appInfo from '../../configs/app-info'
import MsiDatagridGroup from '../custom/MsiDatagridGroup'

interface Props {
    mmgudangId?: number | string | null;
}
export default function Index({ mmgudangId }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const token = userData.token

    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valGudang, setValGudang] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])

    const [listData, setListData] = useState<any[]>([])
    const [loadingData, setLoadingData] = useState<boolean>(false)
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [listWO, setListWO] = useState<any[]>([])
    const [openDialogWO, setOpenDialogWO] = useState<boolean>(false)

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.usage, cabang, token);
            if (response.length > 0 && response.length === 1) {
                setValDoctag(response[0].nama)
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };
        const fetchGudang = async () => {
            const response = await getGudang(token);
            response.forEach((element: any) => {
                if (String(element.id) === mmgudangId) {
                    setValGudang(element.nama)
                    setValue('mmgudang_id', element.id)
                }
            });
            setListGudang(response);
        };
        fetchDoctag();
        fetchGudang();
        getData(tabs)
    }, [mmgudangId])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setLoadingData(true)

        let url = apiUrl.apiUrl + '/mm/usage/list-usage-gudang'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    sysdoctag_id: null,
                    mode: mode,
                    mmgudang_id: mmgudangId
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => showToast(error.response?.data?.message || error.message, 'error'))
            .finally(() => setLoadingData(false))
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/usage/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            showToast(response.data.message, 'success');
                            getData(tabs)
                        } else {
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch(error => {
                        showToast(error.message, 'error');
                    })
            }
        })
    };

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        mmgudang_id: any,
        tgl: any,
        keterangan: any,
        pic: any,
        wo_order_id: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
    }

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Hapus Sales Order",
                icon: "mdi:trash",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/mm/usage/detail/' + id)}
                />
            ),
        },
    ];

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue ? newValue.id : null)
        setValDoctag(newValue.nama)
    }
    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue ? newValue.id : null)
        setValGudang(newValue.nama)
    }

    const getWO = () => {
        axios
            .get(apiUrl.apiUrl + '/mm/usage/list-wo', {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListWO(response.data.data)
                    setOpenDialogWO(true)
                } else {
                    showToast(response.data.message, 'error')
                }
            })
            .catch(error => showToast(error.response?.data?.message || error.message, 'error'))
    }

    const rowClickWO = (event: any) => {
        setValue('wo_order_id', event.data?.id ?? null)
        setOpenDialogWO(false)
    }

    const onSubmit = (data: any) => {
        setOpenDialog(false)
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/usage/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.close();
                            showToast(response.data.message, 'success');
                            navigate('/mm/usage/detail/' + response.data.data)
                        } else {
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch(error => {
                        showToast(error.message, 'error');
                    })
            }
        })
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <Divider />
                <Box
                    sx={{
                        mt: 2,
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        <Fab color='primary' size='medium' onClick={() => setOpenDialog(true)}>
                            <Icon icon='mdi:plus' fontSize={35} color='white' />
                        </Fab>
                    </Box>
                </Box>
                <CardContent>
                    <Grid
                        container
                        sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                        spacing={5}
                    >
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    value={tglAwal}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <Button
                                    variant='contained'
                                    sx={{ mt: 1 }}
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData(tabs)}
                                >
                                    Cari Data
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
                <TabContext value={tabs}>
                    <TabList
                        scrollButtons
                        variant='scrollable'
                        onChange={handleChangeTabs}
                        aria-label='forced scroll tabs example'
                    >
                        <Tab value='0' label='Daftar Usage' />
                        <Tab value='2' label='Outstanding Preview' />
                    </TabList>
                    <TabPanel value='0'>
                        <MsiDatagrid title="Daftar usage" loading={loadingData} array={listData} actions={actionData} />
                    </TabPanel>
                    <TabPanel value='2'>
                        <MsiDatagridGroup title="Usage berdasarkan preview" loading={loadingData} gudangId={mmgudangId} array={listData} groupBy={['preview']} hiddenColumns={['barang_id', 'is_buy']} rowStyleRules={[
                            { field: 'is_buy', operator: '==', value: 0, color: '#ffffff' },
                            { field: 'is_buy', operator: '==', value: 1, color: '#FFF59D' },
                        ]} />
                    </TabPanel>
                </TabContext>
            </Grid>
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='h6' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Buat Usage
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='doctag'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteDoctag}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Document'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valGudang}
                                        options={listGudang}
                                        id='gudang'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        onChange={handleChangeAutocompleteGudang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Gudang'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='datetime-local'
                                                value={value}
                                                label='Tanggal'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl)}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                onChange={onChange}
                                                error={Boolean(errors.pic)}
                                            />
                                        )}
                                    />
                                    {errors.pic && (
                                        <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='wo_order_id'
                                        control={control}
                                        render={({ field: { value } }) => (
                                            <TextField
                                                value={value ?? ''}
                                                label='Work Order'
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Fab color='info' size='medium' onClick={getWO}>
                                    <Icon icon='mdi:magnify' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </form>
            </Dialog>
            <Dialog
                maxWidth='lg'
                fullWidth
                open={openDialogWO}
                onClose={() => setOpenDialogWO(false)}
                aria-labelledby='work-order-dialog-title'
            >
                <DialogTitle id='work-order-dialog-title'>Pilih Work Order</DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <MsiDatagrid title="Pilih work order" array={listWO} rowClick={rowClickWO} hiddenColumns={['id']} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialogWO(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
